import { atom } from 'recoil';

export const chargePointCodeState = atom({
  key: 'chargePointCodeState',
  default: '',
});
